import React, { Component, useState, useEffect, useContext } from 'react';
import { EventContext } from '../CartContext';
import { validateEmail,validateCode,getCustomerData,getCustomerOrders } from '../api-funcs';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Calendar from 'react-calendar'
import { Button, ButtonGroup, Card, CardBody } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MyAccount = () => {
    const { globalEventId } = useContext(EventContext);
    const {accountToken,setAccountToken} = useContext(EventContext);

    const [email, setEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [token, setToken] = useState(null);
    const [customerInfo, setcustomerInfo] = useState(null); 
    const [orderInfo, setOrderInfo] = useState([]);
  
    
    const handleEmailChange = (e) => setEmail(e.target.value);
    const handleVerificationCodeChange = (e) => setVerificationCode(e.target.value);
  
    const handleSend = async () => {
      if (!email) {
        alert('Please enter a valid email address');
        return;
      }
  
      try {
        const response = await validateEmail(email, globalEventId);
        if (response) {
          setIsCodeSent(true);
          alert('Verification code sent to your email!');
        } else {
          alert('Email not found');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Failed to send verification code');
      }
    };
  
    const handleEnter = async () => {
      if (!verificationCode) {
        alert('Please enter the verification code');
        return;
      }
  
      try {
        const userToken = await validateCode(email, globalEventId, verificationCode);
  
        if (userToken) {
          setAccountToken(userToken);
          setIsModalOpen(false); // Close modal
  
          // Fetch additional content after successful verification
        } else {
          alert('Invalid verification code');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Verification failed');
      }
    };

    useEffect(() => {
        const fetchData = async() => {
            await fetchcustomerInfo(accountToken); // Pass the token to API call
            await fetchOrderInfo(accountToken)
        }

        fetchData();

    },[accountToken]);

    const fetchcustomerInfo = async (token) => {
      try {
        const response = await getCustomerData(token);
        if (response !=403) {
            setcustomerInfo(response); // Set the additional content
        }
      } catch (error) {
        console.error('Error fetching additional content:', error);
        
      }
    };

    const fetchOrderInfo = async (token) => {
        try {
          const orders = await getCustomerOrders(token);
          setOrderInfo(orders); // Set the additional content
        } catch (error) {
          console.error('Error fetching additional content:', error);
          
        }
    };
  
    return (
      <>
        <Container className='mt-4'>
          <Row><Col>
            <div>
              <h1>My Account</h1>
  
              {(isModalOpen && !customerInfo) && (
                <div className='validateBox'>
                  <h2>Validate Email</h2>
                  <div>
                    <input
                      type="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={handleEmailChange}
                      disabled={isCodeSent}
                    />
                  </div>
                  <div>
                    {isCodeSent ? (
                      <>
                        <input
                          className='mt-3'
                          type="text"
                          placeholder="Enter Verification Code"
                          value={verificationCode}
                          onChange={handleVerificationCodeChange}
                        /><br/>
                        <Button onClick={handleEnter} className='mt-3 btn-atc'>Enter</Button><br/>
                        <Button onClick={handleSend} className='mt-3 btn-atc'>Resend Code</Button>
                      </>
                    ) : (
                      <Button onClick={handleSend} className='mt-3 btn-atc'>Send</Button>
                    )}
                  </div>
                </div>
              )}
  
              {/* Conditionally render additional content */}
              {(customerInfo  && accountToken) && (
                <Container>
                    <Row className='mb-4 mt-4'>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Name:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_NAME}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Email:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_EMAIL}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Phone:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_PHONE}
                                        </Col>
                                    </Row>
{/*}                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Address:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_ADD_LINE1}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            City:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_ADD_CITY}
                                        </Col>
                                    </Row>
*/}
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Postal Code:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_ADD_POSTAL}
                                        </Col>
                                    </Row>
{/*}                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Prov:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_ADD_PROV}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold cust-info'>
                                            Country:
                                        </Col>
                                        <Col xs={8} className='text-start cust-info'>
                                            {customerInfo?.CUST_ADD_COUNTRY}
                                        </Col>
                                    </Row>
*/}
                              </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col xs={4} className='text-start fw-bold'>
                                            Order #:
                                        </Col>
                                        <Col xs={4} className='text-start fw-bold'>
                                            Date:
                                        </Col>
                                        <Col xs={4} className='text-end fw-bold'>
                                            Amount:
                                        </Col>
                                    </Row>
                                {orderInfo && orderInfo.length > 0 ? (
                                    orderInfo.map((order, index) => (
                                    <>
                                    <Row className='pb-3'>
                                        <Col xs={4} className='text-start'>
                                            <Link to={`order-details/${order.ORDER_NUM}`} style={{ textDecoration: 'none'}}>Order {order.ORDER_NUM}</Link>
                                        </Col>
                                        <Col xs={4} className='text-start m-0 p-0'>
                                            {order.ORDER_DATE}
                                        </Col>
                                        <Col xs={4} className='text-end'>
                                            ${order.ORDER_TOTAL}
                                        </Col>
                                    </Row>
                                    </>
                                    ))
                                    ) : (
                                        <p>No orders available.</p>
                                    )
                                }
                                    <Row>
                                      <Col>
                                        <span className='my-account-info'><i class="bi bi-info-circle"></i> Click the order # to resend / modify your tickets.</span>
                                      </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>
              )}
            </div>
          </Col></Row>
        </Container>
      </>
    );
  };
  

export default MyAccount;
